import { ISpeechAudiogram } from 'gen/ApiClient';

export const calculateVocalIndexImprovement = (aided: ISpeechAudiogram | undefined, unaided: ISpeechAudiogram | undefined) => {
	if (aided === undefined || unaided === undefined) {
		return 0;
	} else {
		return Math.round(unaided.srtIntensity - aided.srtIntensity);
	}
};
